import React from "react"

import styles from "./leftSidebar.module.scss"
//import userDefault from "../../../assets/images/users/default-user-image1.png"

import { Card, Row,Col } from "reactstrap";

const LeftSidebar = (props) => {
    const lead = props.lead;

   console.log(props)
    return (
        <React.Fragment>
            {Array.isArray(lead)?  lead.map((item,idx) => (
                    <div className="p-2" key ={idx}>
                        <Card className={styles.card}>
                        <Row>
                        

                        <Col className="text-center" lg={12}>
                            
                            <h4 className="text-primary">{item.nombre ? item.get_full_name :  item.razon_social} </h4>

                        </Col>
                      </Row>
                        </Card>
                    </div>
   )) : []} 

        </React.Fragment>
    );
}

export default LeftSidebar;